import { ListingDraft, postApiListingsDrafts } from '../../../api/listings-client';

export class SaveDraftQueue {
  private nextSave: { draftData: ListingDraft; callback: (success: boolean) => void } | null = null;
  private isProcessing = false;
  private lastSavedId: string | null = null;

  enqueueSaveDraft(draftData: ListingDraft, callback: (success: boolean) => void): void {
    // Create a shallow copy of the draftData
    this.nextSave = { draftData: { ...draftData }, callback };

    // If not currently processing, start processing
    if (!this.isProcessing) {
      this.processQueue();
    }
  }

  private async processQueue(): Promise<void> {
    if (this.isProcessing || !this.nextSave) return;

    this.isProcessing = true;

    while (this.nextSave) {
      const { draftData, callback } = this.nextSave;
      this.nextSave = null;

      try {
        // Ensure we're using the most recent ID
        draftData.id = this.lastSavedId || draftData.id;

        const response = await postApiListingsDrafts({ requestBody: draftData });
        if (response.listingId) {
          this.lastSavedId = response.listingId;
          callback(true);
        } else {
          callback(false);
        }
      } catch (error) {
        console.error('Error saving draft:', error);
        callback(false);
      }
    }

    this.isProcessing = false;
  }

  getLastSavedId(): string | null {
    return this.lastSavedId;
  }

  getIsProcessing() : boolean {
    return this.isProcessing;
  }
}